import React from 'react';
import { InvoiceData, InvoiceSettings } from '../../../types';
import Standard from './Standard';
import Modern from './Modern';
import Bold from './Bold';
import Spreadsheet from './Spreadsheet';

interface Props {
  data: InvoiceData;
  settings: InvoiceSettings;
  labels: Record<string, string>;
  subtotal: number;
  taxTotal: number;
  total: number;
}

const TemplateDispatcher: React.FC<Props> = (props) => {
  // We use a key based on the template name to force full remounts on template switch
  // for smoother transition animations.
  const templateKey = props.settings.template;

  switch (templateKey) {
    case 'modern':
      return <Modern key="modern" {...props} />;
    case 'bold':
      return <Bold key="bold" {...props} />;
    case 'spreadsheet':
      return <Spreadsheet key="spreadsheet" {...props} />;
    default:
      return <Standard key="standard" {...props} />;
  }
};

export default TemplateDispatcher;
